import { ApiService } from '../../theme/utils/api.service';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { NoInternetHelper } from '../../theme/utils/no-internet-helper';
import { OwnerCredit } from '../../model/syndic/owner-credit';

@Injectable({
  providedIn: 'root'
})
export class OwnerCreditService {

  private url = 'private/trustee/ownercredit';

  constructor(private api: ApiService) { }

  add(data: OwnerCredit): Observable<any> {
    if (!navigator.onLine) {
      NoInternetHelper.internet();
      return Observable.create(obs => { obs.next(); obs.complete(); });
    }
    return this.create(data);
  }

  create(data: OwnerCredit): Observable<any> {
    return this.api._post(`${this.url}/new`, data).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }

  getList(ownerCo?: string): Observable<any[]> {
    if (!navigator.onLine) {
      NoInternetHelper.internet();
      return Observable.create(obs => { obs.next(); obs.complete(); });
    }
    return this.api._get(`${this.url}`, { ownerCo: ownerCo }).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }

  getDelete(uuid: string): Observable<OwnerCredit> {
    if (!navigator.onLine) {
      NoInternetHelper.internet();
      return Observable.create(obs => { obs.next(); obs.complete(); });
    }
    return this.api._delete(`${this.url}/${uuid}/delete`).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }
}
